var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts-contain"},[(_vm.showNum)?_c('div',{staticClass:"top"},[_vm._v("单位("+_vm._s(_vm.unit)+")")]):_vm._e(),_c('div',{staticClass:"o-echarts",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }